import { render, staticRenderFns } from "./HeatmapSwipe.vue?vue&type=template&id=2f06876c"
import script from "./HeatmapSwipe.vue?vue&type=script&lang=js"
export * from "./HeatmapSwipe.vue?vue&type=script&lang=js"
import style0 from "./HeatmapSwipe.vue?vue&type=style&index=0&id=2f06876c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports